module.exports = __webpack_public_path__ + "img/page13-min.6839f418.jpg";